import { Modal, Text } from '@shared/components';

type NotLiveCustomerSendDialogProps = {
  isOpen: boolean;
  customerName?: string;
  tms: string;
  isMakingLive: boolean;
  onMakeLiveAndSend: () => void;
  onSendAsTest: () => void;
  onCancel: () => void;
};

export function NotLiveCustomerSendDialog(p: NotLiveCustomerSendDialogProps) {
  const customer = p.customerName ?? 'this customer';
  const explanation = `Orders for ${customer} still go to a ${p.tms} test environment, so this one won't show up in your ${p.tms}. Make the customer live to send this order, and every order after it, to your ${p.tms}.`;

  return (
    <Modal.Root
      open={p.isOpen}
      onOpenChange={(isOpen) => {
        if (!isOpen && !p.isMakingLive) p.onCancel();
      }}
    >
      <Modal.Content size="medium">
        <Modal.Header title="This customer isn't live yet" hasCloseButton />
        <Text type="body-md" className="px-6">
          {explanation}
        </Text>
        <Modal.Footer className="h-auto flex-wrap gap-3 px-6 py-4">
          <Modal.FooterButton
            onPress={p.onSendAsTest}
            isDisabled={p.isMakingLive}
          >
            Send as a test anyway
          </Modal.FooterButton>
          <Modal.FooterButton
            isPrimary
            onPress={p.onMakeLiveAndSend}
            isDisabled={p.isMakingLive}
          >
            Make live and send
          </Modal.FooterButton>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
}
